export interface Color {
  name: string;
  fixedTone?: number;
  lightTone?: number;
  darkTone?: number;
}
